import { useLocation } from 'react-router';
import { EB_LIMIT } from '../../constants';

const useExtractionBatchSearchParams = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const perPage = Number(searchParams.get('perPage')) || EB_LIMIT;
  const page = Number(searchParams.get('page')) || 0;
  const labelContains = searchParams.get('label__contains') || '';
  const documentId = searchParams.get('document_id') || '';
  const verified = searchParams.get('verified') || '';
  const extractionId = searchParams.get('extraction_id') || '';
  const trainingSetLabel = searchParams.get('training_set_label') || '';
  const createdAt = searchParams.get('created_at') || '';
  const hasUndismissedValidationErrors = searchParams.get('validation_errors') || '';

  const generateSearchParams = (dataPoolId: string) => {
    return {
      page,
      limit: perPage,
      dataPoolId,
      offSet: page * perPage,
      ...(labelContains !== '' && { search: labelContains }),
      ...(verified !== '' && { search: verified }),
      ...(documentId !== '' && { document_id: documentId }),
      ...(extractionId !== '' && { extraction_id: extractionId }),
      ...(trainingSetLabel !== '' && { training_set_label: trainingSetLabel }),
      ...(createdAt !== '' && { created_at: createdAt }),
      ...(hasUndismissedValidationErrors !== '' && {
        validation_errors: hasUndismissedValidationErrors === 'yes' ? 'true' : 'false',
      }),
    };
  };

  return { generateSearchParams };
};

export default useExtractionBatchSearchParams;
